// ══════════════════════════════════════════════
//  Traductions FRANÇAISES — Elghali Car
// ══════════════════════════════════════════════
const fr = {

  nav: {
    home:      'Accueil',
    cars:      'Voitures',
    contact:   'Contact',
    admin:     'Admin',
    langLabel: 'EN',
    langFull:  'English',
  },

  footer: {
    desc:    'Location de voitures à Marrakech et partout au Maroc. Livraison à l\'aéroport, réservation rapide par WhatsApp, assurance incluse.',
    nav:     'Navigation',
    contact: 'Contact',
    rights:  'Tous droits réservés.',
    privacy: 'Confidentialité',
    terms:   'Conditions',
    hours:   '7j/7 · 24h/24',
  },

  home: {
    badge:      'Location de voitures au Maroc',
    heroTitle1: 'Louez une voiture à',
    heroGold:   'Marrakech',
    heroSub:    'Livraison à l\'aéroport Menara, dans votre riad ou partout au Maroc. Réservation rapide par WhatsApp, assurance incluse, prix imbattables.',
    ctaCars:    'Voir les véhicules',
    ctaContact: 'Réserver par WhatsApp',
    scrollLabel:'Défiler',

    stats: {
      vehicles: 'Véhicules',
      clients:  'Clients',
      rating:   'Évaluation',
      years:    'Années d\'expérience',
    },

    whyUs:    'Pourquoi choisir Elghali Car',
    whyTitle: 'Simple, fiable, livré à votre porte',

    features: [
      { title: 'Réservation WhatsApp',   desc: 'Réservez en quelques secondes via WhatsApp, 7j/7 et 24h/24. Confirmation immédiate.' },
      { title: 'Assurance tous risques', desc: 'Tous nos véhicules sont assurés tous risques. Prix tout compris, sans frais cachés.' },
      { title: 'Flotte récente 2020–24', desc: 'Véhicules soigneusement entretenus, propres et contrôlés avant chaque location.' },
      { title: 'Livraison aéroport',     desc: 'Livraison à l\'aéroport Menara de Marrakech et dans toutes les villes du Maroc.' },
    ],

    fleetLabel:  'Notre flotte',
    fleetTitle:  'Véhicules disponibles à Marrakech',
    fleetSub:    'Économiques, SUV, berlines et 4x4 — une voiture pour chaque voyage.',
    seeAll:      'Voir tout →',
    loading:     'Chargement des véhicules...',
    noVehicles:  'Aucun véhicule disponible pour le moment.',
    noVehiclesSub: 'Contactez-nous par WhatsApp pour vérifier la disponibilité.',
    seeFleet:    'Voir toute la flotte →',

    testimonials:     'Témoignages',
    testimonialsTitle:'Ce que disent nos clients',
    testimonialsList: [
      { name: 'Sophie M.',  city: 'Paris, France',    text: 'Livraison à l\'aéroport de Marrakech parfaite ! Voiture propre, prix honnête. Je recommande vivement Elghali Car.' },
      { name: 'Carlos R.',  city: 'Madrid, Espagne',  text: 'Réservation par WhatsApp très rapide. L\'équipe parle français, c\'est très pratique. Expérience excellente !' },
      { name: 'James T.',   city: 'London, UK',       text: 'Best car rental in Marrakech. Delivered to our riad in the medina. Will definitely use again next trip to Morocco.' },
    ],

    ctaTitle1:    'Prêt à explorer le',
    ctaGold:      'Maroc ?',
    ctaSub:       'Contactez-nous par WhatsApp et obtenez votre voiture en quelques minutes. Livraison partout au Maroc.',
    ctaReserve:   '💬 Réserver par WhatsApp',
    ctaContactUs: 'Voir les voitures',
  },

  cars: {
    label:      'Notre Flotte',
    title:      'Location de Voitures à Marrakech',
    found:      (n) => `${n} véhicule${n > 1 ? 's' : ''} trouvé${n > 1 ? 's' : ''}`,
    searchPlaceholder: 'Rechercher une marque ou un modèle...',
    allCategories: 'Tous',
    allStatus:   'Tous statuts',
    available:   '✓ Disponibles',
    unavailable: '✗ Indisponibles',
    reset:       '✕ Réinitialiser',
    loading:     'Chargement des véhicules...',
    noResults:   'Aucun véhicule trouvé',
    noResultsSub:'Essayez de modifier vos critères de recherche.',
    resetFilters:'Réinitialiser les filtres',
    sort: {
      default:    'Par défaut',
      price_asc:  'Prix croissant',
      price_desc: 'Prix décroissant',
      year_desc:  'Année récente',
    },
  },

  detail: {
    breadHome:       'Accueil',
    breadCars:       'Voitures',
    available:       '✓ Disponible',
    unavailable:     '✗ Indisponible',
    pricePerDay:     'Prix / jour',
    tariff:          'Tarif de location',
    madPerDay:       'MAD / jour',
    fuel:            'Carburant',
    transmission:    'Transmission',
    seats:           'Places',
    year:            'Année',
    description:     'Description',
    priceCalc:       '💡 Calculateur de Prix',
    days:            'jours',
    bookedPeriods:   'Périodes déjà réservées :',
    confirmed:       'Confirmé',
    pending:         'En attente',
    reserveBtn:      '🗓️ Réserver ce Véhicule',
    notAvailable:    '❌ Véhicule non disponible',
    notAvailableSub: 'Consultez nos autres véhicules disponibles.',
    backBtn:         '← Voir tous les véhicules',
    notFound:        'Voiture introuvable.',
    loading:         'Chargement...',
    modalTitle:      'Réserver',
    clientInfo:      '👤 Informations Client',
    fullName:        'Nom complet *',
    fullNamePH:      'Ahmed Bennani',
    email:           'Email *',
    phone:           'Téléphone',
    phonePH:         '+212 6 00 00 00 00',
    period:          '📅 Période de Location',
    startDate:       'Date de début *',
    endDate:         'Date de fin *',
    totalEst:        '💰 Total Estimé',
    duration:        (n) => `${n} jour${n > 1 ? 's' : ''} de location`,
    from:            'Du',
    to:              'au',
    notes:           'Notes (optionnel)',
    notesPH:         'Demandes spéciales, lieu de livraison...',
    confirm:         '✅ Confirmer',
    cancel:          'Annuler',
    checking:        '⏳ Vérification...',
    clickStart:      '👆 Cliquez sur une date pour définir le début',
    clickEnd:        '👆 Cliquez sur une date de fin',
    legendSelected:  'Sélectionné',
    legendBooked:    'Déjà réservé',
    legendRange:     'Période choisie',
    successMsg:      (price, days) => `Réservation confirmée ! Total: ${price} MAD pour ${days} jours.`,
  },

  contact: {
    label:       'Contactez-nous',
    title:       'Location Voiture Marrakech',
    subtitle:    'Réservez en Quelques Minutes',
    desc:        'Équipe disponible 7j/7, 24h/24. Réservation rapide par WhatsApp, livraison à l\'aéroport Menara et dans tout le Maroc.',
    address:     'Adresse',
    addressVal:  'Marrakech Mabrouka, 40000 Marrakech',
    phone:       'Téléphone / WhatsApp',
    email:       'Email',
    hours:       'Disponibilité',
    hoursVal:    '7 jours sur 7 · 24h/24',
    whyLabel:    'Pourquoi nous contacter ?',
    whyItems:    ['🗓️ Réservation immédiate par WhatsApp', '✈️ Livraison aéroport Marrakech Menara', '🚗 Devis gratuit en quelques minutes', '🇫🇷 Service en français'],
    formTitle:   '📨 Envoyer un Message',
    fullName:    'Nom Complet *',
    fullNamePH:  'Ahmed Bennani',
    emailField:  'Email *',
    phoneField:  'Téléphone',
    phonePH:     '+33 6 00 00 00 00',
    subject:     'Sujet',
    subjectPH:   '— Choisir un sujet —',
    message:     'Message *',
    messagePH:   'Dates souhaitées, type de véhicule, lieu de livraison...',
    send:        '📨 Envoyer le Message',
    sending:     '⏳ Envoi en cours...',
    successTitle:'Message Envoyé !',
    successMsg:  (name, email) => `Merci ${name} ! Nous vous répondrons très rapidement à ${email}.`,
    sendAnother: '✉️ Envoyer un autre message',
    subjects: [
      { value: 'reservation', label: '🗓️ Demande de réservation' },
      { value: 'devis',       label: '💰 Demande de devis' },
      { value: 'aeroport',    label: '✈️ Livraison aéroport' },
      { value: 'info',        label: '📋 Informations générales' },
      { value: 'autre',       label: '💬 Autre' },
    ],
  },

  notFound: {
    title: 'Page introuvable',
    desc:  'La page que vous cherchez n\'existe pas ou a été déplacée.',
    back:  '← Retour',
    home:  '🏠 Accueil',
  },

  card: {
    reserve:     'Réserver →',
    unavailable: 'Indisponible',
    perDay:      '/j',
    seats:       'places',
  },

  months: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
  days:   ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
};

export default fr;
